<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <v-col cols="12" class="pa-3" v-else>
    <v-row>
      <v-col cols="12" lg="9">
        <v-card
          class="EK-card rounded-xl border-top border-right rounded-tr-0 EK-shadow IMTOrange"
        >
          <v-data-table
            dense
            :headers="headers"
            :items="usersInfoList"
            hide-default-footer
            :search="searchText"
            :items-per-page="10"
            :page.sync="page"
            @page-count="pageCount = $event"
            class="text-center"
          >
            <template v-slot:top>
              <v-text-field
                v-model="searchText"
                color="IMThemeGray"
                style="width: 280px"
                append-icon="mdi-magnify"
                label="بحث في الجدول"
                class="mx-4"
              ></v-text-field>
            </template>
            <template v-slot:item="{ item, index }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <tr
                    v-on="on"
                    v-bind="attrs"
                    @click="
                      goToDetails(usersInfoList.findIndex((user) => user.id == item.id))
                    "
                    :class="{
                      active: (page - 1) * 10 + index == userIndex,
                    }"
                  >
                    <td :class="!item.reqeustDelete ? '' : 'red--text'">
                      {{ item.firstName }}
                    </td>
                    <td :class="!item.reqeustDelete ? '' : 'red--text'">
                      {{ item.lastName }}
                    </td>
                    <td :class="item.verificationDate ? '' : 'red--text'">
                      {{ item.phoneNumber }}
                    </td>
                    <td>
                      {{ new Date(item.birthDate).toISOString().substr(0, 10) }}
                    </td>
                    <td>
                      {{ new Date(item.createdAt).toISOString().substr(0, 10) }}
                    </td>
                    <td>

                        {{ item.verificationDate == null ?  "لا يوجد"  : new Date(item.verificationDate).toISOString().substr(0, 10) }}
                    </td>
                    <td>
                      {{ !!item.cityName ? item.cityName : "---" }}
                    </td>
                    <td>{{ item.areaName }}</td>
                    <td>
                      <v-btn
                        @click="
                          ConfirmDelete({
                            item,
                            index,
                          })
                        "
                        text
                      >
                        <img src="/media/svg/table/delete.svg" alt="delete" />
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <span>انقر لعرض التفاصيل</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <div class="w-100 mt-5">
            <a-pagination
            :showTotal="(total) => `من أصل ${total} عنصر`"
            pageSize="10"

              v-model="page"
              :total="usersInfoList.length"
              @showSizeChange="page"
              size="large"
              
              show-quick-jumper
            />
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3" class="align-items-center d-flex">
        <router-view v-if="!!userIndex"></router-view>
        <h5 v-else>يرجى تحديد سطر لعرض التفاصيل</h5>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import loading from "@/components/loading";
import { mapGetters, mapActions } from "vuex";
import aPagination from "ant-design-vue/lib/pagination";
export default {
  props: {
    userIndex: String,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    searchText: "",
    headers: [
      {
        text: "الاسم الكامل  ",
        value: "firstName",
      },
   
      {
        text: "رقم الهاتف",
        value: "phoneNumber",
      },
      {
        text: "تاريخ الميلاد",
        value: "birthDate",
      },
      {
        text: "تاريخ الإنشاء",
        value: "createdAt",
      },
      {
        text: "تاريخ آخر تحقق",
        value: "verificationDate",
      },
      {
        text: "المحافظة",
        value: "cityName",
      },
      {
        text: "المنطقة",
        value: "areaName",
      },
      {
        text: "حذف",
        value: "delete",
        sortable: false,
      },
    ],
  }),
  components: {
    loading,
    aPagination,
  },
  computed: {
    ...mapGetters(["usersInfoList", "isLoading"]),
  },
  created() {
    this.fetchUserInfo();
    this.setBreadcrumbs([
      {
        text: "مشتركو التطبيق",
      },
    ]);
  },
  methods: {
    ...mapActions(["fetchUserInfo", "ConfirmDelete", "setBreadcrumbs"]),
    goToDetails(index) {
      if (index != this.userIndex) {
        this.$router.push("/user-info/" + index);
      }
    },
  },
};
</script>
